import { combineReducers } from 'redux';
import profileSuggestionsReducer from './profileSuggestionsReducer';
var rootReducer = combineReducers({
  profileSuggestions: profileSuggestionsReducer
});
export default rootReducer;